import useOtp from "./hooks"

const Otp = ({
  otpToken,
  phoneNumber,
  hasDefaultButton = false,
  onContinue,
  onInvalid,
  setIsValid,
}) => {
  useOtp({
    otpToken,
    onContinue,
    hasDefaultButton,
    setIsValid,
    onInvalid,
  })

  return (
    <itau-otp
      token={otpToken}
      phoneNumber={phoneNumber}
      hasDefaultButton={hasDefaultButton}
    ></itau-otp>
  )
}

export default Otp
